<template>
  <div>
    <BannerInternoDois
    :titulo="'Fale conosco'"
    :subtitulo="'Envie-nos uma mensagem'"
    :lead="'Em breve nosso time entrará em contato com você.'"
    ></BannerInternoDois>
    <div class="contato ui-container">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 col-12">
            <div class="box">
              <div class="titulo">
                O que você deseja?
              </div>
              <form @submit.prevent="submitForm">
                <ul class="row justify-content-center align-items-center">
                  <li>
                    <a href="https://www.comcasa.com.br/cms/#/login" target="_blank">
                      <div class="dado">
                        Sou cliente
                      </div>
                    </a>
                  </li>
                  <li v-for="(item,index) in contactSectors" :key="index">
                    <div class="dado" :class="{'active' : option == index}" @click="aciveOption(index); contactAddress(item.email, item.subject); showSelect(item.id);">
                      {{item.name}}
                    </div>
                  </li>
                </ul>
                <!-- este input é o valor escolhido acima -->
                <input type="text" style="display: none" :value="option">
                <div class="inputs w-100">
                  <div class="row">
                    <div class="col-12">
                      <div class="group w-100">
                        <span class="highlight"></span>
                        <input type="text" v-model="form.name" required>
                        <span class="bar"></span>
                        <label>Nome completo</label>
                      </div>
                    </div>
                    <div class="col-md-6 col-12">
                      <div class="group w-100">
                        <span class="highlight"></span>
                        <input type="text" v-model="form.email" required>
                        <span class="bar"></span>
                        <label>E-mail</label>
                      </div>
                    </div>
                    <div class="col-md-6 col-12">
                      <div class="group w-100">
                        <span class="highlight"></span>
                        <the-mask required="" type="text" v-model="form.phone" :mask="['(##) ####-####', '(##) #####-####']" />
                        <span class="bar"></span>
                        <label>Telefone</label>
                      </div>
                    </div>
                    <div class="col-md-6 col-12">
                      <div class="select w-100">
                        <span class="highlight"></span>
                        <select class="select-text" v-model="form.state" required>
                          <option disabled="">Estado</option>
                          <option v-for="(item,index) in uf" :key="index" :value="item.sigla">{{item.nome}}</option>
                        </select>
                        <span class="select-highlight"></span>
                        <span class="select-bar"></span>
                        <label class="select-label">Estado</label>
                      </div>
                    </div>
                    <div class="col-md-6 col-12">
                      <div class="select w-100">
                        <span class="highlight"></span>
                        <select class="select-text" v-model="form.city" required>
                          <option disabled="">Cidade</option>
                          <option v-for="(item,index) in cidades" :key="index" v-if="form.state == item.mesorregiao.UF.sigla">{{item.nome}}</option>
                        </select>
                        <span class="select-highlight"></span>
                        <span class="select-bar"></span>
                        <label class="select-label">Cidade</label>
                      </div>
                    </div>
                    <div class="col-12" v-if="valueSelect == 1">
                      <div class="select w-100">
                        <select class="select-text" v-model="form.empreendiments" required>
                          <option disabled="">Escolha um imóvel</option>
                          <option :value="item.slug" v-for="(item,index) in empreendimentos" :key="index">{{item.title}}</option>
                          <option :value="'Quero obter informações dos imóveis'">Quero obter informações dos imóveis</option>
                          <option :value="'Não defini um imóvel específico de interesse'">Não defini um imóvel específico de interesse</option>
                        </select>
                      <span class="select-highlight"></span>
                      <span class="select-bar"></span>
                      <label class="select-label">Escolha um imóvel</label>
                      </div>
                    </div>
                    <div class="col-12 mt-3">
                      <div class="group w-100">
                        {{valueUF}}
                        <span class="highlight"></span>
                        <textarea rows="6" v-model="form.message" required=""></textarea>
                        <span class="bar"></span>
                        <label>Mensagem</label>
                      </div>
                    </div>
                    <div class="col-12">
                      <button type="submit" class="ui-button" :disabled="disabled">
                        {{submitButton}}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="col-lg-4 col-12">
            <div class="titulo_contato">
              Localização
            </div>
            <address>
              {{contatoData.address}}
            </address>
            <div class="local">
              <a :href="contatoData.address_link" target="_blank" class="pop">
                <i class="fa fa-map-marker"></i> Saiba como chegar
              </a>
            </div>
            <div class="titulo_contato">
              Entre em contato
            </div>
            <div class="telefone" v-if="contatoData.phone && contatoData.phone_formated">
              <a :href="'tel:'+contatoData.phone" class="pop">
                <i class="fa fa-phone"></i> {{contatoData.phone_formated}}
              </a>
            </div>
            <div class="telefone" v-if="contatoData.cellphone && contatoData.cellphone_formated">
              <a :href="'https://api.whatsapp.com/send?phone='+contatoData.cellphone" target="_blank" class="pop">
                <i class="fa fa-whatsapp"></i> {{contatoData.cellphone_formated}}
              </a>
            </div>
            <div class="email">
              <a :href="'mailto:'+contatoData.email" class="pop">
                {{contatoData.email}}
              </a>
            </div>
            <div class="buttons">
              <a v-for="(item,index) in socialNetworks" v-if="item.type == 'facebook'" :key="index" :href="item.link" target="_blank">
                <button class="ui-button ui-button--transparent ui-button--italic">
                  <i class="fa fa-facebook"></i> Acompanhe nosso Facebook
                </button>
              </a>
              <a v-for="(item,index) in socialNetworks" v-if="item.type == 'whatsapp'" :key="index" target="_blank" :href="'whatsapp://send?phone=55'+item.link">
                <button class="ui-button ui-button--italic">
                  <i class="fa fa-whatsapp"></i> Converse conosco no WhatsApp
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BannerInternoDois from './BannerInternoDois.vue'
import ContatoMapa from './ContatoMapa.vue'
import {TheMask} from 'vue-the-mask'
import { mapGetters } from 'vuex'
import swal from 'sweetalert2'
import axios from 'axios'
export default {
  data () {
    return {
      option: 0,
      destiny: '',
      subject: '',
      empreendimento: this.$route.params.slug,
      disabled: false,
      submitButton: 'Enviar mensagem',
      form: {
        name: '',
        email: '',
        phone: '',
        state: '',
        city: '',
        empreendiments: localStorage.getItem('empreendimento') ? localStorage.getItem('empreendimento') : '',
        message: ''
      },
      contatoData: {},
      valueSelect: '1',
      uf: '',
      cidades: '',
      valueUF: ''
    }
  },
  components: {
    BannerInternoDois,
    TheMask,
    ContatoMapa
  },
  methods: {
    aciveOption (a) {
      this.option = a
    },
    contactAddress (email, subject) {
      this.destiny = email
      this.subject = subject
    },
    showSelect (id) {
      this.valueSelect = id
    },
    submitForm () {
      this.disabled = true
      this.submitButton = 'Enviando'
      var empreendiment = ''
      if (this.$route.params.slug || this.form.empreendiments) {
        empreendiment = `Empreendimento: ${this.form.empreendiments} <br>`
        for (var i = 0; i < this.empreendimentos.length; i++) {
          if (this.empreendimentos[i].slug === this.form.empreendiments) {
            empreendiment = `Empreendimento: ${this.empreendimentos[i].title} <br>`
          }
        }
      }
      let content = {
        'destiny': this.destiny,
        'originName': 'Website Comcasa',
        'title': this.subject,
        'message': `
          Uma pessoa entrou em contato pelo website da Comcasa:<br><br>
          Nome: ${this.form.name}<br>
          E-mail: ${this.form.email}<br>
          Telefone: ${this.form.phone}<br>
          Estado: ${this.form.state}<br>
          Cidade: ${this.form.city}<br>
          ${empreendiment}
          Mensagem: ${this.form.message}
        `
      }
      this.$store.dispatch('sendContactForm', {data: content})
        .then(() => {
          this.$store.dispatch('sendActiveCampaign', {data: this.form})
          swal(
            'Enviado :)',
            'E-mail enviado com sucesso.',
            'success'
          )
          this.form = {
            name: '',
            email: '',
            phone: '',
            state: '',
            city: '',
            empreendiments: '',
            message: ''
          }
          this.submitButton = 'Enviar mensagem'
          this.disabled = false
        })
    }
  },
  computed: {
    ...mapGetters([
      'contactSectors',
      'companyData',
      'socialNetworks',
      'empreendimentos'
    ])
  },
  created () {
    this.form.empreendiments = this.$route.params.slug
    this.$store.dispatch('listContactSectors')
      .then(() => {
        this.destiny = this.contactSectors[0].email
        this.subject = this.contactSectors[0].subject
      })
    this.$store.dispatch('listCompanyData')
      .then(() => {
        this.contatoData = this.companyData
        if (this.contatoData.cellphone) {
          let cellphoneP1 = this.contatoData.cellphone.slice(0, 2)
          let cellphoneP2 = this.contatoData.cellphone.slice(2, 6)
          if (this.contatoData.cellphone.length === 11) {
            cellphoneP2 = this.contatoData.cellphone.slice(2, 7)
          }
          let cellphoneP3 = this.contatoData.cellphone.slice(-4)

          this.contatoData.cellphone_formated = cellphoneP1 + '. ' + cellphoneP2 + '.' + cellphoneP3
        }

        if (this.contatoData.phone) {
          let phoneP1 = this.contatoData.phone.slice(0, 2)
          let phoneP2 = this.contatoData.phone.slice(2, 6)
          if (this.contatoData.phone.length === 11) {
            phoneP2 = this.contatoData.phone.slice(2, 7)
          }
          let phoneP3 = this.contatoData.phone.slice(-4)

          this.contatoData.phone_formated = phoneP1 + '. ' + phoneP2 + '.' + phoneP3
        }
      })
    this.$store.dispatch('loadSocialNetworks')
    let params = {
      page: '',
      filter: '',
      category: '',
      notPaginate: 1,
      for_sale: 1,
      delivered: ''
    }
    this.$store.dispatch('loadEmpreendimentos', params)
  },
  mounted () {
    axios
      .get('https://servicodados.ibge.gov.br/api/v1/localidades/estados')
      .then(response => {
        this.uf = response.data.sort(function (a, b) {
          if (a.sigla > b.sigla) {
            return 1
          } if (a.sigla < b.sigla) {
            return -1
          }
          return 0
        })
      })
    axios
      .get('https://servicodados.ibge.gov.br/api/v1/localidades/microrregioes')
      .then(response => {
        this.cidades = response.data.sort(function (a, b) {
          if (a.nome > b.nome) {
            return 1
          } if (a.nome < b.nome) {
            return -1
          }
          return 0
        })
      })
    localStorage.removeItem('empreendimento')
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";
.contato {
  background: $bgIntern;
  .box {
    background: white;
    border-radius: 10px;
    box-shadow: 10px 0px 35px 0px rgba(0, 26, 66, 0.2);
    padding: 40px;
  }
  .titulo {
    color: $primary;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 40px;
  }
  li {
    cursor: pointer;
    margin: 0 5px 15px 5px;
    text-align: center;
    .dado {
      background: white;
      border: 1px $effect solid;
      border-radius: 50px;
      color: $effect;
      font-size: 16px;
      min-width: 150px;
      padding: 15px;
      @media (max-width: 1200px) {
        min-width: 185px;
      }
    }
    .active {
      background: $primary;
      color: white;
    }
  }
  .inputs {
    margin-top: 20px;
  }
  button {
    min-width: inherit;
    width: 100%;
  }
  .titulo_contato {
    color: $primary;
    font-size: 26px;
    font-weight: 900;
    margin: 50px 0;
    text-transform: uppercase;
  }
  address {
    color: $tabs;
    font-size: 18px;
    font-style: italic;
    line-height: 28px;
  }
  .telefone {
    margin-bottom: 20px;
    a {
      color: $primary;
      font-size: 26px;
      font-weight: bold;
      transition: all 0.3s;
      &:hover {
        transition: all 0.3s;
        color: $green;
      }
    }
  }
  .email {
    margin-bottom: 80px;
    a {
      color: $tabs;
      font-size: 18px;
      font-style: italic;
      font-weight: 300;
      transition: all 0.3s;
      &:hover {
        transition: all 0.3s;
        color: $green;
      }
    }
  }
  .local {
    margin-bottom: 30px;
    a {
      color: $tabs;
      font-size: 16px;
      text-decoration: underline!important;
      transition: all 0.3s;
      &:hover {
        transition: all 0.3s;
        color: $green;
      }
    }
  }
  .buttons {
    button {
      margin-bottom: 10px;
    }
  }
  @media (max-width: 1200px) {
    .buttons {
      button {
        font-size: 15px;
        padding-left: 5px;
        padding-right: 5px;
        i {
          margin-right: 5px;
        }
      }
    }
    .box {
      padding: 20px;
    }
    .titulo {
      margin-bottom: 20px;
    }
    li {
      .dado {
        font-size: 15px;
        padding: 10px;
      }
    }
  }
  @media (max-width: 991px) {
    .email {
      margin-bottom: 20px;
    }
    .titulo_contato {
      margin-bottom: 20px;
      margin-top: 20px;
    }
    .buttons {
      button {
        font-size: 18px;
        i {
          margin-right: 5px;
        }
      }
    }
    li {
      margin-bottom: 5px;
      width: 100%;
    }
  }
  @media (max-width: 767px) {
    .titulo_contato {
      font-size: 24px;
    }
    .buttons {
      button {
        font-size: 15px;
        i {
          margin-right: 5px;
        }
      }
    }
    .box {
      margin-bottom: 20px;
    }
  }
}
.group {
  position:relative;
  margin-bottom:30px;
}
input, textarea {
  padding:10px 10px 10px 5px;
  display:block;
  width: 100%;
  border:none;
  border-bottom:1px solid $effect;
  color: $silver;
  font-size: 16px;
  font-style: italic;
  font-weight: 300;
}
input:focus {
  outline:none;
}
textarea:focus {
  outline:none;
}
label {
  color:$effect;
  font-size:16px;
  font-weight:300;
  font-style: italic;
  position:absolute;
  pointer-events:none;
  left:5px;
  top:10px;
  transition:0.2s ease all;
  -moz-transition:0.2s ease all;
  -webkit-transition:0.2s ease all;
}
input:focus ~ label, input:valid ~ label {
  top:-20px;
  font-size:14px;
  color:$primary;
}
textarea:focus ~ label, textarea:valid ~ label {
  top:-20px;
  font-size:14px;
  color:$primary;
}
.bar {
  position:relative;
  display:block;
  width: 100%;
}
.bar:before, .bar:after {
  content:'';
  height:2px;
  width:0;
  bottom:1px;
  position:absolute;
  background:$primary;
  transition:0.2s ease all;
  -moz-transition:0.2s ease all;
  -webkit-transition:0.2s ease all;
}
.bar:before {
  left:50%;
}
.bar:after {
  right:50%;
}
input:focus ~ .bar:before, input:focus ~ .bar:after {
  width:50%;
}
textarea:focus ~ .bar:before, textarea:focus ~ .bar:after {
  width:50%;
}
.highlight {
  position:absolute;
  height:60%;
  width:100px;
  top:25%;
  left:0;
  pointer-events:none;
  opacity:0.5;
}
input:focus ~ .highlight {
  -webkit-animation:inputHighlighter 0.3s ease;
  -moz-animation:inputHighlighter 0.3s ease;
  animation:inputHighlighter 0.3s ease;
}
textarea:focus ~ .highlight {
  -webkit-animation:inputHighlighter 0.3s ease;
  -moz-animation:inputHighlighter 0.3s ease;
  animation:inputHighlighter 0.3s ease;
}
@-webkit-keyframes inputHighlighter {
  from {
    background:$primary;
  }
  to {
    background:transparent;
    width:0;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background:$primary;
  }
  to {
    width:0;
    background:transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background:$primary;
  }
  to {
   background:transparent;
    width:0;
  }
}
.select {
  position: relative;
  width: 100%;
  margin-bottom: 30px;
}
.select-text {
  position: relative;
  font-size: 16px;
  font-weight: 300;
  font-style: italic;
  background-color: transparent;
  width: 100%;
  padding: 10px 10px 10px 0;
  font-size: 18px;
  border-radius: 0;
  border: none;
  border-bottom: 1px solid $effect;
}
.select-text:focus {
  outline: none;
  border-bottom: 1px solid $effect;
}
.select .select-text {
  appearance: none;
-webkit-appearance:none
}
.select:after {
  position: absolute;
  top: 18px;
  right: 10px;
  width: 0;
  height: 0;
  padding: 0;
  content: '';
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid $effect;
  pointer-events: none;
}
.select-label {
  color: $effect;
  font-size: 16px;
  font-weight: 300;
  font-style: italic;
  position: absolute;
  pointer-events: none;
  left: 0;
  top: 10px;
  transition: 0.2s ease all;
}
.select-text:focus ~ .select-label, .select-text:valid ~ .select-label {
  color: $primary;
  top: -20px;
  transition: 0.2s ease all;
font-size: 14px;
}
.select-bar {
  position: relative;
  display: block;
  width: 100%;
}
.select-bar:before, .select-bar:after {
  content: '';
  height: 2px;
  width: 0;
  bottom: 1px;
  position: absolute;
  background: $primary;
  transition: 0.2s ease all;
}
.select-bar:before {
  left: 50%;
}
.select-bar:after {
  right: 50%;
}
.select-text:focus ~ .select-bar:before, .select-text:focus ~ .select-bar:after {
  width: 50%;
}
.select-highlight {
  position: absolute;
  height: 60%;
  width: 100px;
  top: 25%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/Contato.vue